import './home.css'
import Fade from 'react-reveal/Fade';
import KaryaTerbaruCard from './karyaTerbaru-card';

export default function Home(){
    return(
        <div id="home" className="d-flex flex-column my-5">
            <div id='home-profile' className='d-flex mx-5 mb-5'>
                <div className='ms-5'>
                    <Fade left>
                        <h1 className='display-1 font-weight-bold text-oren m-0'>
                            Dominic<br/>
                            Christiansen
                        </h1>
                        <i><h3>Art Director</h3></i>
                    </Fade>
                    <Fade bottom>
                        <p className='w-75 mt-5'>
                                Halo para filmmakers! Selamat datang di website saya. Nama saya Dominic Christiansen dan saya merupakan seorang Art Director atau Production Designer dalam industri perfilman Indonesia. Saat ini saya berdomisili di Jakarta dan Tangerang.
                                <br />
                                <br />
                                Di dalam website ini anda akan menemukan berbagai pengalaman dan karya yang telah saya buat. Mulai dari karya-karya dua tahun kebelakang hingga karya terbaru saya dapat anda lihat di dalam website ini. 
                        </p>
                    </Fade>
                </div>
                <Fade right>
                    <img className='me-5' src="./profile.png" alt="photoProfile" />
                </Fade>
            </div>

            <div id='karya-wrapper' className='my-5 mx-5'>
                <div className='mb-3'>
                    <Fade left>
                        <h1 className='text-oren m-0 d-flex align-items-center'>
                            Karya Terbaru 
                            <span id='tahun' className='m-0'>2021 - 2022</span>
                        </h1>
                    </Fade>
                </div>
                <div className='row row-cols-xl-3 row-cols-1 gap-5 justify-content-evenly'>
                    <KaryaTerbaruCard value='1' tahun="2" valueIntext='satu' image='1.png' textTop='Surro' textDown='Helies Pictures' />
                    <KaryaTerbaruCard value='2' tahun="2" valueIntext='dua' image='12.jpeg' textTop='Cahaya Cinta Perlahan Menyilaukan' textDown='UMN Pictures' />
                    <KaryaTerbaruCard value='3' tahun="1" valueIntext='tiga' image='9.png' textTop='What Now' textDown='Swakarya Production' />
                    <KaryaTerbaruCard value='4' tahun="2" valueIntext='empat' image='11.png' textTop='Tehman Ads' textDown='Acierto Visuals' />
                </div>
            </div>
            <div id='segera-hadir' className='my-5'>
                <h1 className='text-oren mb-3'>Segera hadir</h1>
                <div className='d-flex align-items-center position-relative'>
                    <div id='image-slider' className='w-100 d-flex gap-5 pb-3'>
                        <img src="./Project/3.png" alt="" />
                        <img src="./Project/2.png" alt="" />
                        <img src="./Project/5.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}